import React from 'react';

// Component
import FareByAirlineInMonth from './FareByAirlineInMonth';

interface ISection {
  days?: any,
  handleSelectTrip?: any
  isDesktop?: any
}

function Section05(props: Partial<ISection>) {
  const {
    days, handleSelectTrip, isDesktop,
  } = props;

  return (
    <FareByAirlineInMonth
      days={days}
      isDesktop={isDesktop}
      onSelectTrip={handleSelectTrip}
      numberDayInMonth={3}
    />
  );
}

export default React.memo(Section05);
